import { cloneElement, type ReactElement } from 'react';
import { Tooltip } from '@meshble/molo';
import type { Permessi } from './session';
import { t } from './lib/lingua';
import { titoloDi } from './lib/permessi';

/**
 * Un pulsante che chi guarda non può usare si vede disabilitato, con il
 * motivo (blocco 35, D2): «perché non posso?» ha una risposta sul posto,
 * invece di un 403 dopo il clic.
 *
 * Il pulsante disabilitato non riceve il mouse, quindi il tooltip sta su un
 * involucro che si raggiunge anche da tastiera. È cortesia: decide l'hub.
 */
export function ConPermesso({ ha, serve, children }: {
  ha: Permessi;
  serve: string | string[];
  children: ReactElement<{ disabled?: boolean }>;
}) {
  const manca = (Array.isArray(serve) ? serve : [serve]).find((p) => !ha(p));
  if (!manca) return children;
  return (
    <Tooltip content={t('Serve «{permesso}», che qui non hai.', { permesso: t(titoloDi(manca)) })}>
      <span className="md-vietato" tabIndex={0}>{cloneElement(children, { disabled: true })}</span>
    </Tooltip>
  );
}
